import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { ToastContext } from "../context/ToastContext";
import { useContext } from "react";

export const useUngroup = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/actions/groups/receivables`,
    (url: string, { arg }: { arg: { groupId: string } }) =>
      fetcher(`${url}/${arg.groupId}`, {
        method: "DELETE",
      }),
    {
      onError: () => {
        showToast("Failed to delete invoices group, please try again later", "error");
      },
    }
  );

  return {
    ungroup: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
